{
  "name": "@ns/task",
  "version": "1.0.0",
  "authorable": true,
  "description": "A generic task: someone reads what to do, does it, and marks it done with an optional note.",
  "inputs": {
    "TITLE": {
      "type": "string"
    },
    "INSTRUCTIONS": {
      "type": "string",
      "optional": true
    }
  },
  "outcomes": {
    "done": {
      "inputs": {
        "NOTE": {
          "type": "string",
          "optional": true
        }
      }
    }
  }
}
